const Head2 = ({text}) => {
    return(<div className="portfolio_h2">{text}</div>)
}

export default Head2;